import { Duo, EntraId, Fido2, Hypr, Microsoft, Okta, Ping, Rsa } from './components';
import type { TokenComponentProps } from './components';
import { SUBCATEGORIES } from '../../common/categories';

export type PredefinedTokenKey =
    | 'duoMfaToken'
    | 'rsaMfaToken'
    | 'oktaMfaToken'
    | 'pingMfaToken'
    | 'microsoftMfaToken'
    | 'hyprMfaToken'
    | 'fido2MfaToken'
    | 'entraIdMfaToken';

const {
    DUO_MFA_TOKEN,
    RSA_MFA_TOKEN,
    OKTA_MFA_TOKEN,
    PING_MFA_TOKEN,
    MICROSOFT_MFA_TOKEN,
    HYPR_MFA_TOKEN,
    FIDO2_MFA_TOKEN,
    ENTRA_ID_MFA_TOKEN
} = SUBCATEGORIES;

export const tokenComponentsMap = {
    duoMfaToken: { component: Duo as React.FC<TokenComponentProps<any, any>>, id: DUO_MFA_TOKEN.ID },
    rsaMfaToken: { component: Rsa as React.FC<TokenComponentProps<any, any>>, id: RSA_MFA_TOKEN.ID },
    oktaMfaToken: { component: Okta as React.FC<TokenComponentProps<any, any>>, id: OKTA_MFA_TOKEN.ID },
    pingMfaToken: { component: Ping as React.FC<TokenComponentProps<any, any>>, id: PING_MFA_TOKEN.ID },
    microsoftMfaToken: {
        component: Microsoft as React.FC<TokenComponentProps<any, any>>,
        id: MICROSOFT_MFA_TOKEN.ID
    },
    hyprMfaToken: { component: Hypr as React.FC<TokenComponentProps<any, any>>, id: HYPR_MFA_TOKEN.ID },
    fido2MfaToken: { component: Fido2 as React.FC<TokenComponentProps<any, any>>, id: FIDO2_MFA_TOKEN.ID },
    entraIdMfaToken: { component: EntraId as React.FC<TokenComponentProps<any, any>>, id: ENTRA_ID_MFA_TOKEN.ID }
} as const satisfies Record<PredefinedTokenKey, { component: React.FC<TokenComponentProps<any, any>>; id: string }>;
